module.exports = __webpack_public_path__ + "static/img/c35.a63b46f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c35.png
// module id = 277
// module chunks = 0 1 2 3 4 5 6 7 8 9